import { render, staticRenderFns } from "./TransferCompanySectionView.vue?vue&type=template&id=d0edcdbc&scoped=true&"
import script from "./TransferCompanySectionView.vue?vue&type=script&lang=js&"
export * from "./TransferCompanySectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0edcdbc",
  null
  
)

export default component.exports